import styled from 'styled-components';

import { StyledText as StyledTextBase } from './loyalty-text-widget.styled.base';

export const StyledText = styled(StyledTextBase)`
  font-size: 0.75rem;
`;
